module.exports = __webpack_public_path__ + "static/media/google-docs-icon.8515c928.svg";